export var environment = {
    production: true,
    baseApiURL: "https://api-staging.pumpr.io/",
    env: "staging"
}; 